// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2WFHp","small":"Button_small__2-4Cv","positive":"Button_positive__D1FAh"};